<template>
<div>
	<div class="row">

		<div class="col">

			<b-jumbotron class="mb-3 p-4">
				<h1 class="display-4">{{ $t('auction.auctionPhotos') }}</h1>

				<p>
					{{ $t('auction.photoFileExample') }}: <strong>{{ $t('auction.photoFilenameExample') }}</strong>
				</p>

				<form enctype="multipart/form-data"
				      novalidate
				      class="mb-4">

					<b-alert v-if="mediaErrors.length > 0"
					         show
					         variant="warning">
						<span v-for="error in mediaErrors">
				  				{{ error }}<br />
						</span>
					</b-alert>

					<div class="dropbox"
					     v-bind:class="{ hovered: hoverDropbox }">
						<input type="file"
						       v-on:dragenter="dragEnter"
						       v-on:dragleave="dragLeave"
						       v-on:drop="dragLeave"
						       v-if="isUploading == false"
						       multiple
						       @change="filesChange($event.target.files); fileCount = $event.target.files.length"
						       accept="image/*"
						       class="input-file">

						<div class="dropbox-info"
						     v-if="uploadingFileCount < 1">
							Plaats uw bestanden hier om te beginnen
							<br /> of klik om te selecteren
						</div>

						<div class="row dropbox-info justify-content-center"
						     v-if="uploadingFileCount > 0">
							<div class="col-sm-12 col-md-6">
								<b-progress :value="uploadingStatus"
								            variant="info"
								            striped
								            animated
								            height="2rem"
								            class="mb-2"></b-progress>
								{{ fileCount - uploadingFileCount }} van {{ fileCount }} bestanden aan het uploaden...
							</div>

						</div>
					</div>
				</form>

				<div class="row media">
					<div v-for="(media, index) in mediaItems"
					     class="col col-xl-1 col-lg-2 col-md-3 col-sm-4 media-item">
						<figure class="media-item-image"
							:style="{ backgroundImage: 'url(' + small(media.url) + ')' }">
						</figure><!-- :style="`background-image: url(small(${media.url}));`" -->
					</div>
				</div>

			</b-jumbotron>
		</div>

	</div>

</div>
</template>

<script>
import { isNil } from 'lodash';
import AuctionService from '@/services/auction-service';
import { flashSuccess } from '@/helpers/flash-message-helper';

export default {
	data() {
		return {
			hoverDropbox: false,
			deletingKey: false,
			uploadingStatus: 0,
			uploadingFileCount: 0,
			selectedDeleteMedia: null,
			mediaItems: [],
			isUploading: false,
			mediaErrors: [],
			fileCount: 0
		}
	},
	methods: {
		small(url){
			let chunk 		= url.split('/');
			let file_name 	= chunk[chunk.length - 1];
			let small_name 	= 'small_' + file_name;

			return url.replace(file_name, small_name);
		},
		dragEnter(event) {
			this.hoverDropbox = true;
		},
		dragLeave(event) {
			this.hoverDropbox = false;
		},
		filesChange(fileList) {
			this.isUploading = true;
			this.uploadingStatus = 0;
			this.uploadingFileCount = fileList.length;

			// handle file changes
			if (!fileList.length) return;

			this.uploadFile(fileList, 0);
		},
		uploadFile(fileList, startAtFile) {

			if(startAtFile >= fileList.length) {
				// list is empty, nothing to upload
				return;
			}

			// pick a file from the filelist
			const file = fileList.item(startAtFile);
			const auctionId = this.$route.params.auctionId;

			// create formdata to send to server
			const formData = new FormData();
			formData.append('file', file);

			// upload media item
			AuctionService.uploadMedia(auctionId, formData)
				.then(
					response => ({
						error: null,
						response: response
					}),
					error => ({
						error: error
					})
				)
				.then(
					({ error, response }) => {

						// set uploading status
						this.isUploading = false;
						this.uploadingFileCount--;
						this.uploadingStatus += Math.round((100 / fileList.length));

						if(!error) {
							this.mediaItems.push(response);
						} else {
							// handle error
							if (error.response.request.status == 400) {
								this.mediaErrors.push(error.response.data.errors.file[0]);
							} else {
								this.mediaErrors.push(error.message);
							}
						}

						// set timeout of a half second and than upload a new file
						setTimeout(this.uploadFile(fileList, (startAtFile + 1)), 500);

					}
				);


		}
	},
	mounted() {

	}
}
</script>

<style lang="scss" scoped>
.media {
    &-item {
        &-image {
            background-size: cover;
            background-position: center center;
            height: 100px;
            width: 100%;
            position: relative;

            &-delete {
                display: none;
                height: 230px;
                width: 100%;
                background-color: rgba(255,0,0, .3);
                color: #fff;
                text-align: center;
                vertical-align: middle;
                line-height: 230px;
                border: none;
            }
            &:hover &-delete {
                display: block;
            }

            &-loader {
                height: 230px;
                width: 100%;
                background-color: rgba(255,0,0, .3);
                color: #fff;
                text-align: center;
                vertical-align: middle;
                line-height: 250px;
            }
        }
    }
}
.dropbox {
    outline: 2px dashed grey;
    /* the dash box */
    //outline-offset: -10px;
    //background: lightcyan;
    color: dimgray;
    margin: 0 2px;
    height: 200px;
    /* minimum height */
    position: relative;
    cursor: pointer;

    &.hovered {
        background-color: #f1f1f1;
    }

    .input-file {
        opacity: 0;
        /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    &-info {
        margin: 0;
        padding: 0;
        font-size: 1.2em;
        text-align: center;
        padding-top: calc(100px - 1.5em);
    }
}
</style>



// WEBPACK FOOTER //
// Photos.vue?3d8750da